module.exports = __webpack_public_path__ + "img/home-restaurant-thumb-04.177b337a.jpg";